// extracted by mini-css-extract-plugin
export var animateCircle = "contacts-module--animate-circle--oS+Zk";
export var bounce = "contacts-module--bounce--yv5sY";
export var contacts = "contacts-module--contacts--5jfMK";
export var contactsItem = "contacts-module--contactsItem--UXxDY";
export var contactsItemData = "contacts-module--contactsItemData--8gklb";
export var contactsItemName = "contacts-module--contactsItemName--H-hzA";
export var contactsWrap = "contacts-module--contactsWrap--sqrTZ";
export var ldsRing = "contacts-module--lds-ring--duxFe";